import { useState, useEffect } from 'react';
import { getLocale } from '../api/user';
import { Currency, getCurrencies } from '../api/paymentRequests';

export function useCurrencies(providerName?: string) {
  const [isLoading, setIsLoading] = useState(true);
  const [currencies, setCurrencies] = useState<Currency[]>();
  const [defaultCurrencyCode, setDefaultCurrencyCode] = useState('');
  useEffect(() => {
    const fetchData = async () => {
      const { result: currencies } = await getCurrencies(providerName);
      setCurrencies(currencies);
      const localeCurrencyCode = (await getLocale()).country.defaultCurrencyCode;
      setDefaultCurrencyCode(
        currencies.some(({ code }) => code == localeCurrencyCode) ? localeCurrencyCode : 'USD',
      );
      setIsLoading(false);
    };
    fetchData();
  }, [providerName]);

  return { isLoading, defaultCurrencyCode, currencies };
}
